import { Link } from 'react-router-dom';

export default function ContactHero() {
  return (
    <section className="relative min-h-[60vh] flex items-center overflow-hidden bg-[#F8F5F0]">
      {/* Right image */}
      <div className="absolute top-0 right-0 w-[46%] h-full hidden lg:block">
        <img
          src="https://readdy.ai/api/search-image?query=professional%20insurance%20advisor%20warm%20welcoming%20office%20reception%20desk%20natural%20light%20calm%20trustworthy%20atmosphere%20minimal%20clean%20modern%20interior&width=900&height=700&seq=contacthero001&orientation=squarish"
          alt="聯絡保險建築師"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#F8F5F0] via-[#F8F5F0]/55 to-transparent"></div>
      </div>

      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{ backgroundImage: 'radial-gradient(#5C5470 1px, transparent 1px)', backgroundSize: '24px 24px' }}
      ></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 pt-28 pb-20">
        <div className="max-w-[560px]">
          <div className="inline-flex items-center gap-2 bg-[#5C5470]/10 border border-[#5C5470]/20 rounded-full px-4 py-2 mb-8">
            <span className="w-2 h-2 rounded-full bg-[#D4A373]"></span>
            <span className="text-[#5C5470] font-medium" style={{ fontSize: '1rem' }}>預約一對一諮詢</span>
          </div>

          <h1
            className="font-serif font-bold text-[#5C5470] mb-6"
            style={{ fontSize: 'clamp(2rem, 4vw, 2.75rem)', lineHeight: '1.3' }}
          >
            聯絡我們
            <br />
            <span className="text-[#D4A373]">把您的擔心，</span>
            <br />
            交給專業來整理
          </h1>

          <p
            className="text-[#5C5470]/75 mb-10"
            style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}
          >
            不確定自己適合什麼保障？先不用急著買新的保單。
            您可以先預約諮詢，讓保險建築師陪您看懂現況、找出缺口、排出優先順序。
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#contact-form"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('contact-form')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center justify-center gap-2 bg-[#D4A373] text-white px-8 py-4 rounded-full font-semibold whitespace-nowrap hover:bg-[#c4935f] transition-all duration-200 hover:scale-105 cursor-pointer"
              style={{ fontSize: '1.1875rem' }}
            >
              <i className="ri-calendar-check-line"></i>
              預約一對一諮詢
            </a>
            <a
              href="https://lin.ee/6XFYSq2"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 border-2 border-[#5C5470] text-[#5C5470] px-8 py-4 rounded-full font-semibold whitespace-nowrap hover:bg-[#5C5470] hover:text-white transition-all duration-200"
              style={{ fontSize: '1.1875rem' }}
              aria-label="加入 LINE 諮詢"
            >
              <i className="ri-line-fill"></i>
              加入 LINE 諮詢
            </a>
          </div>

          <div className="mt-12 lg:hidden rounded-2xl overflow-hidden aspect-[16/9]">
            <img
              src="https://readdy.ai/api/search-image?query=professional%20insurance%20advisor%20warm%20welcoming%20office%20reception%20desk%20natural%20light%20calm%20trustworthy%20atmosphere%20minimal%20clean%20modern%20interior&width=800&height=450&seq=contacthero002&orientation=landscape"
              alt="聯絡保險建築師"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
